import { WebSocketTextMessageInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { showToast } from '@/utils/showToast';

export default async function processTextMessage(
  webSocketTextMessageInterface: WebSocketTextMessageInterface,
): Promise<void> {
  if (!webSocketTextMessageInterface.senderUserId) {
    showToast({
      type: 'info',
      message: webSocketTextMessageInterface.text,
    });
  } else {
    showToast({
      type: 'error',
      message: `Unexpected message from the server: ${webSocketTextMessageInterface.text}`,
    });
  }
}
